import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import SmallPieGraph from "../../../general/SmallPieGraph";
import PieGraph from "../../../general/PieGraph";
import styles from "./HealthL1.module.css";

function HealthL1({ distrito, healthValues, setHealthProperties1 }) {
  const {
    frequenciaExameValue,
    atendimentoAmbulanciaValue,
    sistemaSaudeValue,
    usoMedicamentoValue,
    dificuldadeAtendimentoValue,
    qualidadeSSMunicipalValue,
    qualidadeSSRuralValue,
    possuiDoencaCronicaValue,
    tipoDoencaCronicaValue,
    programaSaudeRuralValue,
  } = healthValues;

  const {
    setFrequenciaExameValue,
    setAtendimentoAmbulanciaValue,
    setSistemaSaudeValue,
    setFrequenciaExameImage,
    setAtendimentoAmbulanciaImage,
    setSistemaSaudeImage
  } = setHealthProperties1

  const [frequenciaExame, setFrequenciaExame] = useState(null);
  const [atendimentoAmbulancia, setAtendimentoAmbulancia] = useState(null);
  const [sistemaSaude, setSistemaSaude] = useState(null);
  const [frequenciaExameOldValue, setFrequenciaExameOldValue] = useState(null);
  const [atendimentoAmbulanciaOldValue, setAtendimentoAmbulanciaOldValue] =  useState(null);
  const [sistemaSaudeOldValue, setSistemaSaudeOldValue] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [frequenciaExame, atendimentoAmbulancia, sistemaSaude] = await Promise.all([
          Api.getFrequenciaExame(distrito),
          Api.getAtendimentoAmbulancia(distrito),
          Api.getSistemaSaude(distrito),
        ]);
        setFrequenciaExame(Functions.buildPieGraphParams2(frequenciaExame));
        setAtendimentoAmbulancia(Functions.buildPieGraphParams2(atendimentoAmbulancia));
        setSistemaSaude(Functions.buildSmallPieGraphParams(sistemaSaude));
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [distrito]);

  if (loading) return <div className={styles.healthL1}></div>;

  const onFrequenciaExameClick = (value) => {
    setFrequenciaExameValue(value);
  };

  const onAtendimentoAmbulanciaClick = (value) => {
    setAtendimentoAmbulanciaValue(value);
  };

  const onSistemaSaudeClick = (value) => {
    setSistemaSaudeValue(value);
  };

  const onFrequenciaExameOldValue = (value) => {
    setFrequenciaExameOldValue(value);
  };

  const onAtendimentoAmbulanciaOldValue = (value) => {
    setAtendimentoAmbulanciaOldValue(value);
  };

  const onSistemaSaudeOldValue = (value) => {
    setSistemaSaudeOldValue(value);
  };

  return (
    <div className={styles.generalConditionL1}>
      {frequenciaExame && (
        <div className={styles.smallPiegraph}>
          <PieGraph
            data={frequenciaExame}
            text="FREQUÊNCIA DE EXAMES"
            onLegendClick={onFrequenciaExameClick}
            currentValue={frequenciaExameValue}
            oldValue={frequenciaExameOldValue}
            onOldValue={onFrequenciaExameOldValue}
            onImageReady={setFrequenciaExameImage}
          />
        </div>
      )}

      {atendimentoAmbulancia && (
        <div className={styles.smallPiegraph}>
          <PieGraph
            data={atendimentoAmbulancia}
            text="ATENDIMENTO AMBULÂNCIA"
            onLegendClick={onAtendimentoAmbulanciaClick}
            currentValue={atendimentoAmbulanciaValue}
            oldValue={atendimentoAmbulanciaOldValue}
            onOldValue={onAtendimentoAmbulanciaOldValue}
            onImageReady={setAtendimentoAmbulanciaImage}
          />
        </div>
      )}

      {sistemaSaude && (
        <div className={styles.smallPiegraph}>
          <SmallPieGraph
            data={sistemaSaude}
            text="SISTEMA DE SAÚDE"
            onLegendClick={onSistemaSaudeClick}
            currentValue={sistemaSaudeValue}
            oldValue={sistemaSaudeOldValue}
            onOldValue={onSistemaSaudeOldValue}
            onImageReady={setSistemaSaudeImage}
          />
        </div>
      )}
    </div>
  );
}

export default HealthL1;
